import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enumToArray'
})
export class EnumToArrayPipe implements PipeTransform {

  transform(value: any): any {
    return Object.keys(value).map(key => ({ key, value: value[key] }));
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/enum-to-array.pipe.ts